import type { CSSVariablesResolver } from '@mantine/core';

export const resolver: CSSVariablesResolver = () => ({
  variables: {
    '--locs-terracotta': '#b95736',
    '--locs-signature-dark': '#103d2b',
    '--locs-espresso': '#1b120b',
    '--locs-darkroom': '#2e1b10',
    '--locs-forest': '#245b45',
    '--locs-gold': '#9c7420',
    '--locs-brass-green': '#6f8f63',
    '--locs-on-signature': '#fff8e7',
    '--locs-on-signature-muted': 'rgba(255, 248, 231, 0.72)',
  },
  light: {
    // Mantine Native System Overrides
    '--mantine-color-body': '#f7f4ee',
    '--mantine-color-text': '#2a190e',
    '--mantine-color-dimmed': '#6b5543',
    '--mantine-color-default': '#fffefa',
    '--mantine-color-default-border': '#d8c8b3',
    '--mantine-color-default-hover': '#efe8da',
    '--mantine-color-default-color': '#2a190e',
    '--mantine-color-placeholder': '#9b8873',

    // Pure Semantic Domain Tokens
    '--locs-canvas': '#f7f4ee',
    '--locs-canvas-muted': '#eee7db',
    '--locs-panel': '#fffefa',
    '--locs-sidebar': '#ede9e1',
    '--locs-photo-mat': '#efe8da',
    '--locs-text': '#2a190e',
    '--locs-text-muted': '#6b5543',
    '--locs-border-faint': '#e8ddcc',
    '--locs-border': '#d8c8b3',
    '--locs-border-strong': '#b99b78',
    '--locs-metal-line': '#d8ba67',
    '--locs-strand-ink': 'rgba(27, 18, 11, 0.08)',
    '--control-bg': '#fffefa',
    '--control-border': '#c8b59e',
  },
  dark: {
    // Mantine Native System Overrides
    '--mantine-color-body': '#130D08',
    '--mantine-color-text': '#F7F4EE',
    '--mantine-color-dimmed': '#E4D8CC',
    '--mantine-color-default': '#2A1D14',
    '--mantine-color-default-border': 'rgba(216, 186, 103, 0.38)',
    '--mantine-color-default-hover': '#35251A',
    '--mantine-color-default-color': '#F7F4EE',
    '--mantine-color-placeholder': '#C3B3A3',

    // Pure Semantic Domain Tokens
    '--locs-canvas': '#130D08',
    '--locs-canvas-muted': '#21160E',
    '--locs-panel': '#2A1D14',
    '--locs-sidebar': '#180E09',
    '--locs-photo-mat': '#2A1F16',
    '--locs-text': '#F7F4EE',
    '--locs-text-muted': '#E4D8CC',
    '--locs-border-faint': 'rgba(216, 186, 103, 0.22)',
    '--locs-border': 'rgba(216, 186, 103, 0.38)',
    '--locs-border-strong': 'rgba(216, 186, 103, 0.62)',
    '--locs-metal-line': 'rgba(216, 186, 103, 0.56)',
    '--locs-strand-ink': 'rgba(247, 244, 238, 0.06)',
    '--control-bg': '#2A1D14',
    '--control-border': 'rgba(216, 186, 103, 0.42)',
  },
});
